import { createMutationHook, createQueryHook } from "../factory";
export const lifecycleRoles = {
  getLifecycleRoles: createQueryHook({
    methodSelector: (client) => client.lifecycleRoles.getLifecycleRoles,
    queryKeyFn: (input: { insurerId?: string }) =>
      ["lifecycleRoles", "getLifecycleRoles", input] as const,
  }),
  getRolePermissionMatrix: createQueryHook({
    methodSelector: (client) => client.lifecycleRoles.getRolePermissionMatrix,
    queryKeyFn: (input: { roleId: string; insurerId?: string }) =>
      ["lifecycleRoles", "getRolePermissionMatrix", input] as const,
  }),
  createLifecycleRole: createMutationHook({
    methodSelector: (client) => client.lifecycleRoles.createLifecycleRole,
    mutationKey: ["lifecycleRoles", "createLifecycleRole"],
  }),
  duplicateLifecycleRole: createMutationHook({
    methodSelector: (client) => client.lifecycleRoles.duplicateLifecycleRole,
    mutationKey: ["lifecycleRoles", "duplicateLifecycleRole"],
  }),
  updateLifecycleRole: createMutationHook({
    methodSelector: (client) => client.lifecycleRoles.updateLifecycleRole,
    mutationKey: ["lifecycleRoles", "updateLifecycleRole"],
  }),
  deleteLifecycleRole: createMutationHook({
    methodSelector: (client) => client.lifecycleRoles.deleteLifecycleRole,
    mutationKey: ["lifecycleRoles", "deleteLifecycleRole"],
  }),
  saveRolePermissionMatrix: createMutationHook({
    methodSelector: (client) => client.lifecycleRoles.saveRolePermissionMatrix,
    mutationKey: ["lifecycleRoles", "saveRolePermissionMatrix"],
  }),
};
